import { useSuspenseQuery } from '@apollo/client';
import {
  GetSkuProductsDocument,
  GetSkuProductsQuery,
} from '@storefront/data-commerce';
import {
  getCoreOffer,
  getNameFromBundleItemOption,
} from '@storefront/utils/prodRequests';
import { BundleProductWithLowestPrice } from '@storefront/app/pdp-config/printer/product-configuration/product-configuration.utils';
import { Cancel } from '@storefront/types/Product';

export function useProductCancellationList(skus: string[]) {
  const {
    data: { products },
  } = useSuspenseQuery<GetSkuProductsQuery>(GetSkuProductsDocument, {
    variables: { skuList: skus },
  });

  const multipleProduct = products?.items as BundleProductWithLowestPrice[];

  const cancellationList = multipleProduct.map((product) => {
    const { items, hp_cancellation_json, price_range } = product;
    const { cancellation } = JSON.parse(hp_cancellation_json) as Cancel;
    const productName = getNameFromBundleItemOption(
      getCoreOffer(items[0], product)
    );

    return {
      name: productName,
      cancellation,
      currency: price_range?.minimum_price?.regular_price?.currency,
    };
  });

  const hasThreeYearsCancellationDate = cancellationList.some(
    (cancel) => !!cancel.cancellation?.[4]?.['37M-_']
  );

  return { multipleProduct, cancellationList, hasThreeYearsCancellationDate };
}
